import React from "react";
import { chatApi } from "../../lib/api";

const COLORS = [
  "#2563EB", "#10B981", "#F59E0B", "#8B5CF6", "#EF4444",
  "#06B6D4", "#EC4899", "#14B8A6", "#6366F1", "#F97316",
];

export function colorFor(seed = "") {
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) >>> 0;
  return COLORS[h % COLORS.length];
}

export function initialsFor(name = "") {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "?";
  return (parts[0][0] + (parts[1]?.[0] || "")).toUpperCase();
}

const PRESENCE = {
  online: "#22C55E",
  away: "#F59E0B",
  offline: "#94A3B8",
};

const SIZES = {
  sm: { box: "h-7 w-7 text-[10px]", dot: "h-2 w-2" },
  md: { box: "h-9 w-9 text-[12px]", dot: "h-2.5 w-2.5" },
  lg: { box: "h-10 w-10 text-[13px]", dot: "h-3 w-3" },
};

/** Avatar that shows an uploaded image (chat avatarUrl) or colored initials, with an optional presence dot. */
export default function ChatAvatar({ name, avatarUrl, presence, size = "md", showPresence = true, ring = false }) {
  const s = SIZES[size] || SIZES.md;
  const src = avatarUrl ? chatApi.fileUrl(avatarUrl) : null;
  return (
    <div className="relative shrink-0" data-testid="chat-avatar">
      <div
        className={`${s.box} rounded-lg flex items-center justify-center font-bold text-white overflow-hidden ${ring ? "ring-2 ring-white" : ""}`}
        style={{ background: colorFor(name) }}
      >
        {src ? <img src={src} alt={name} className="h-full w-full object-cover" /> : initialsFor(name)}
      </div>
      {showPresence && presence && (
        <span
          className={`absolute -bottom-0.5 -right-0.5 ${s.dot} rounded-full border-2 border-white`}
          style={{ background: PRESENCE[presence] || PRESENCE.offline }}
          title={presence}
        />
      )}
    </div>
  );
}
